
/**
 * 학습 진도 업데이트 요청
 */
export interface EnrollmentProgressUpdateRequest {
  /**
   * 새로운 학습 진도율 (0-100)
   * @minimum 0
   * @maximum 100
   */
  progressPercentage: number;
}
